import styled, { createGlobalStyle } from 'styled-components';
import { Layout } from 'antd';
import { DndProvider } from 'react-dnd';
import { ResponsiveWidth } from 'components/Css';

const { Content } = Layout;

export const GlobalStyle = createGlobalStyle`
  body, html {
    background-color: var(--color-neutral-light-lighter) !important;
  }
`;

export const Provider = styled(DndProvider)`
  .mobileViewer & {
    zoom: 0.5;
    width: 400px;
  }
`;

export const Background = styled(Content)`
  background-color: var(--color-button-text)
`;

export const Container = styled.div`
  max-width: 1260px;
  width: 100%;
  display: flex;
  justify-content: center; 
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
`;

export const BarRadius = styled.div`
  @media (max-width: ${ResponsiveWidth}px) {
    height: var(--borderRadiusBase);
    border-radius: var(--borderRadiusBase) var(--borderRadiusBase) 0px 0px;
    margin-top: calc(-1 * var(--borderRadiusBase));
    background-color: var(--colorBgBase);
  }
`;
